import Scrollama from 'vue-scrollama'
export default {
  data () {
    return {
      show1: true,
      show2: false,
      show3: false,
      imgList: [],
      info: {}
    }
  },
  components: {
    Scrollama
  },
  methods: {
    stepEnterHandler1 ({element, index, direction}) {
      switch (element.className) {
        case 'step1':
          this.show2 = true
          break
        case 'step2':
          this.show3 = true
          break
        case 'step3':
          this.show3 = true
          break
      }
    },
    swiperleft () {
      this.$refs.carousel.next()
    },
    swiperright () {
      this.$refs.carousel.prev()
    },
    swiperCusLeft () {
      this.$refs.cusCarousel.next()
    },
    swiperCusRight () {
      this.$refs.cusCarousel.prev()
    }
  },
  beforeDestroy () {
  },
  mounted: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.info = this.$boss.pageApp2.gApp2[0]
      this.imgList = [this.info.productPicture]
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/phone/index.js